import { StringSchema } from 'yup';
import api from './api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';

export interface Oi {
    usuarioMatricula: any;
    projetoCodigo: string;
    pacoteOiCodigo: string;
    pacoteOiNome: string;
    pacoteOiOi: string;
    situacao: string;
    ultimaAtualizacao: string;
    possuiRfa: string;
    projetoNome: string;
    matriculaResponsavel: string;
    acronimoId: string;
    index: number;
    projetoId: string;
    ordemId: string;
    nomeUsuaro: string;
    projetoNumero: string;
    numeroLinha: number;
    diretoria: string;
    area: string;
    departamento: string;

    diretoriaSigla: string;
    areaSigla: string;
    departamentoSigla: string;

    tipoPacoteTipoNome: string;
    tipoPacoteDisciplinaNome: string;
}




export const getAllOrdemInvestimento = () => { return api.get<Oi[]>('projetos/getAllOrdemInvestimento'); }


export const getExportarLelatorioOi = () => {
    let urlBase = window.location.origin;
    trackPromise(
        Axios.get(
            urlBase +
            `/api/projetos/getAllOrdemInvestimentoExportaExecel`,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${getJwt()}`,
                },
            },
        ).then(resp => {

            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'relatorioProjetoOis.xlsx');
            link.setAttribute('id', 'downloadElement');
            document.body.appendChild(link);
            link.click();
            document.getElementById('downloadElement').outerHTML = '';
        }),
    );
}